export const ListQueryKey = 'cates';
export const DetailQueryKey = 'cate';

export const Urls = {
  selectUrl: '/projectcate/list',
  updateUrl: '/projectcate/update',
  deleteUrl: '/projectcate/delete',
  createUrl: '/projectcate/create',
  detailUrl: '/projectcate/detail',
};
